import type { GBlockCenterProps } from '~/presentation/ui';
import type { TextProps } from '@shopify/polaris';

import { GBlockCenter } from '~/presentation/ui';
import { Text } from '@shopify/polaris';
import { cls } from '~/utils';

interface RankBadgeProps {
  rank: number;
  tone?: 'dark' | 'light';
}

const TEXT_COLOR: Record<'dark' | 'light', TextProps['tone'] | undefined> = {
  dark: 'inherit',
  light: 'subdued',
};

const BOX_STYLE: Record<'dark' | 'light', GBlockCenterProps> = {
  dark: {
    borderWidth: '0',
    background: 'bg-surface-inverse',
  },
  light: {
    borderColor: 'border-tertiary',
  },
};

export const RankBadge: React.FC<RankBadgeProps> = ({ rank, tone = 'light' }) => {
  const textColor = TEXT_COLOR[tone];
  const boxStyle = BOX_STYLE[tone];

  return (
    <GBlockCenter
      width="20px"
      height="20px"
      paddingInline="050"
      paddingBlock="100"
      borderRadius="full"
      borderWidth="025"
      {...boxStyle}
    >
      <div
        className={cls({
          'text-white': tone === 'dark',
        })}
      >
        <Text as="p" variant="bodyXs" tone={textColor} fontWeight="semibold">
          {rank}
        </Text>
      </div>
    </GBlockCenter>
  );
};
